import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import logo from "../assets/logo.png"; // make sure this is the correct path

function Header() {
  const { token, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleLoginClick = () => {
    if (token) {
      alert("You're already logged in!");
    } else {
      navigate("/login");
    }
  };

return (
  <header className="app-header">
    <div className="header-inner">
      <div className="logo-title">
        <img src={logo} alt="RaptorID Logo" className="logo" />
        <h1>RaptorID</h1>
      </div>

      <nav className="nav-buttons">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/identify" className="nav-link">Identify</Link>
        <Link to="/journal" className="nav-link">Journal</Link>
        {token ? (
          <button onClick={handleLogout} className="logout-button">Logout</button>
        ) : (
          <button onClick={handleLoginClick} className="logout-button">Login</button>
        )}
      </nav>
    </div>
  </header>
);

}

export default Header;
